/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import { lazy } from 'react';
import { Redirect, Switch, Route, useHistory, useRouteMatch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Layout } from '../_metronic/layout';
// import BasePage from './BasePage';
// import { Logout, AuthPage } from './modules/Auth';
import ErrorsPage from './modules/ErrorsExamples/ErrorsPage';
import AuthPage from './modules/Auth/pages/AuthPage';
import Logout from './modules/Auth/pages/Logout';
import { useLiffInit } from './hooks/useLiffInit';
import ShoppingCartButton from './components/ShoppingCartButton';
import LineContactButton from './components/LineContactButton';
import { ErrorBoundary } from 'react-error-boundary';
import Fallback from './modules/ErrorsExamples/Fallback';
import SuperAdminAuthPage from './modules/Auth/pages/SuperAdminAuthPage';
import { COUNTRY_CODE } from '@/config';
const BasePage = lazy(() => import('./BasePage'));

const Routes = () => {
  const authToken = useSelector(state => state.auth.authToken);

  const history = useHistory();
  const matchShop = useRouteMatch('/shop/:shopId/');
  const redeemMatch = useRouteMatch('/shop/:shopId/redeem/:redeemId');

  const isLiff = window.location.href.includes('liff.state');

  const { liffLoaded } = useLiffInit({ enabled: isLiff });

  if (isLiff && !liffLoaded) return <div>Loading liff...</div>;

  if (!authToken) {
    if (redeemMatch && redeemMatch.params.shopId && redeemMatch.params.redeemId) {
      history.replace(`/shop/${matchShop.params.shopId}/login?redeem=${redeemMatch.params.redeemId}`);
    }
  }

  return (
    //For some reson ErrorBoundary in index.js cannot catch errors inside Layout
    <ErrorBoundary FallbackComponent={Fallback}>
      <Switch>
        <Route path="/error" component={ErrorsPage} />
        <Route path="/shop/management" component={SuperAdminAuthPage} />
        {!authToken && (
          <Route>
            <AuthPage />
          </Route>
        )}
        <Route path="/logout" component={Logout} />
        {authToken && (
          <Layout>
            <ShoppingCartButton top="64px" marginTop="0px" />
            {COUNTRY_CODE === 'TH' && <LineContactButton />}
            <BasePage />
          </Layout>
        )}

        <Redirect to="/error" />
      </Switch>
    </ErrorBoundary>
  );
};

export default Routes;
